import * as Sentry from '@sentry/react';
import { get } from 'lodash';
import { updateJwtToken } from 'modules/session/actions/updateJwtToken';
import { logout } from 'modules/auth/actions/logout';
import hasGraphQLErrors from 'shared/utils/hasGraphQLErrors';
import store from 'store/configureStore';
import {
  INVALID_JWT,
  EMPTY_JWT,
  INVALID_SESSION_ERROR,
  INVALID_REFRESH_TOKEN,
} from 'modules/session/constants/globalErrorCodes';

const handleJWTErrors = (callFn, params) =>
  store.dispatch(updateJwtToken())
    .then(() => callFn({
        ...params,
        notifyOnNetworkStatusChange: undefined,
      }),
    );

const handleInvalidSession = (error) => {
  store.dispatch(logout(true, true));
  throw error;
};

/**
 * @param callFn
 * @param params
 * @return {*}
 */

const getVariablesForSentry = (variables) => {
  if (variables && variables.password) {
    delete variables.password;
  }

  return variables;
};

export default (callFn, params) => {
  return callFn(params)
    .catch((error = {}) => {
      if (error.graphQLErrors && !hasGraphQLErrors(error, [INVALID_JWT])) {
        Sentry.withScope(
          scope => {
            scope
            .setLevel('warning')
            .setExtra('message', get(error, 'graphQLErrors[0].message') || error.graphQLErrors)
            .setExtra('query', get(params, 'mutation.loc.source.body') || get(params, 'query.loc.source.body'))
            .setExtra('variables', getVariablesForSentry(get(params, 'variables')));

            Sentry.captureException(error);
          },
        );
      }

      switch (true) {
        case !error.graphQLErrors:
          throw error;
        case hasGraphQLErrors(error, [INVALID_SESSION_ERROR, INVALID_REFRESH_TOKEN]):
          return handleInvalidSession(error);
        case hasGraphQLErrors(error, [INVALID_JWT, EMPTY_JWT]):
          return handleJWTErrors(callFn, params);
        default:
          throw error;
      }
    });
};
